import Handler from "../Handler";

class PrivateTableGameDefInfoFailure extends Handler {
  execute(message) {
    this.service.processPrivateTableGameDefInfoFailure();
  }
}
export default PrivateTableGameDefInfoFailure;
// privateTableInfoF#